import HeaderWrapperDesktop from "./header-wrapper-desktop"
import { Link } from "react-router-dom"
import ImageBox from "../../../components/image-box"

const LOGO_SRC = "/images/toicos-logo-a.png"

const CubiqHeaderDesktop = ({ title = "큐빅 미터스", position = "sticky" }) => {
  return (
    <HeaderWrapperDesktop position={position}>
      <Link to={"/select"} className="flex gap-2 justify-center items-center mr-auto">
        <ImageBox className={"w-6 h-6"} src={LOGO_SRC} />
        <h1 className="text-lg font-bold text-center whitespace-pre">{title}</h1>
      </Link>
    </HeaderWrapperDesktop>
  )
}

export default CubiqHeaderDesktop
